import { Transition } from '@headlessui/react';

import { Spinner } from '@/common/components/elements/spinner';

interface LaunchScreenProps {
  isLoading: boolean;
}

export const LaunchScreen = ({ isLoading }: LaunchScreenProps) => {
  return (
    <Transition show={isLoading}>
      <div
        data-testid='launch-screen'
        className='absolute transition duration-300 z-50 ease-in data-closed:opacity-0'
      >
        <div className='bg-gradient-blue-special fixed top-0 left-0 w-full h-full flex justify-center items-center'>
          <div className='flex flex-col items-center gap-10'>
            <Spinner className='text-[#333] fill-white' />
          </div>
        </div>
      </div>
    </Transition>
  );
};
